export class CodedError extends Error {
   public code: string;
   public status: number;

   constructor(message: string, code: string, status: number = 500) {
      super(message);
      this.code = code;
      this.status = status;
   }
}
